// extracted by mini-css-extract-plugin
export default {"invoiceInfoBlock":"tjM0eLCemNARzHVetypt"};